import { FC } from "react";

import s from "./Label.module.scss";

interface Props {
  id: string;
  label: string | number;
  required?: boolean;
}

export const Label: FC<Props> = ({ id, label, required }) => {
  return (
    <label htmlFor={id} className={s.Label}>
      {label}
      {required && <span className={s.Required}> *</span>}
    </label>
  );
};
